export var ottHeaderConstants;
(function (ottHeaderConstants) {
    ottHeaderConstants["AB_PROFILE_ID"] = "X-SkyOTT-ABProfileId";
    ottHeaderConstants["PROVIDER"] = "X-SkyOTT-Provider";
    ottHeaderConstants["PROPOSITION"] = "X-SkyOTT-Proposition";
    ottHeaderConstants["TERRITORY"] = "X-SkyOTT-Territory";
    ottHeaderConstants["BROADCAST_REGIONS"] = "X-SkyOTT-BroadcastRegions";
    ottHeaderConstants["PLATFORM"] = "X-SkyOTT-Platform";
    ottHeaderConstants["DEVICE"] = "X-SkyOTT-Device";
    ottHeaderConstants["DEVICE_ID"] = "X-SkyOTT-DeviceId";
    ottHeaderConstants["X_DEVICE_ID"] = "X-DeviceID";
    ottHeaderConstants["LANGUAGE"] = "X-SkyOTT-Language";
    ottHeaderConstants["COUNTRY"] = "X-SkyOTT-Country";
    ottHeaderConstants["POSTAL_CODE"] = "X-SkyOTT-PostalCode";
    ottHeaderConstants["OVP_PIN_OVERRIDE"] = "X-SkyOTT-PinOverride";
    ottHeaderConstants["USER_TOKEN"] = "X-SkyOTT-UserToken";
    ottHeaderConstants["SIGNATURE"] = "X-Sky-Signature";
    ottHeaderConstants["TOKEN_TYPE"] = "X-SkyOTT-TokenType";
    ottHeaderConstants["ID_TOKEN"] = "X-SkyId-Token";
    ottHeaderConstants["TOKEN"] = "X-Token";
    ottHeaderConstants["COPPA"] = "X-SkyOTT-COPPA";
    ottHeaderConstants["PAS"] = "X-SkyOTT-PAS";
    ottHeaderConstants["PAS_ALTERNATE"] = "X-SkyOTT-PAS-Alternate";
    ottHeaderConstants["PARTNER_ID"] = "X-SkyOTT-PartnerId";
    ottHeaderConstants["IDENTIFIERS"] = "X-SkyOTT-Identifiers";
    ottHeaderConstants["PARTNER_ACCOUNT_ID"] = "X-SkyOTT-PartnerAccountId";
    ottHeaderConstants["PRE_PLAYOUT"] = "X-SkyOTT-PrePlayout";
    ottHeaderConstants["DEVICE_LANGUAGE"] = "X-SkyOTT-DeviceLanguage";
    ottHeaderConstants["APP_STORE_TERRITORY"] = "X-SkyOTT-AppStoreTerritory";
    ottHeaderConstants["ACTIVE_TERRITORY"] = "X-SkyOTT-ActiveTerritory";
    ottHeaderConstants["REQUEST_ID"] = "X-SkyInt-RequestId";
    ottHeaderConstants["ISO_TIME_STAMP"] = "X-SkyInt-IsoTimestamp";
    ottHeaderConstants["DEBUG"] = "X-SkyOTT-Debug";
    ottHeaderConstants["BOUQUET_ID"] = "X-SkyOTT-BouquetId";
    ottHeaderConstants["SUB_BOUQUET_ID"] = "X-SkyOTT-SubBouquetId";
    ottHeaderConstants["CLIENT_VERSION"] = "X-SkyOTT-Client-Version";
    ottHeaderConstants["JOURNEY_CONTEXT"] = "X-SkyOTT-JourneyContext";
    ottHeaderConstants["ENDORSEMENTS"] = "X-SkyOTT-Endorsements";
    ottHeaderConstants["VERSION"] = "X-Sky-Version";
})(ottHeaderConstants || (ottHeaderConstants = {}));
//# sourceMappingURL=ott-header-constants.js.map